import type { Poll } from 'models';
import { useMemo } from 'react';
import { generateAttachmentsInputInitialValue, getDatePickerDateType } from 'ui';

import type { PollFormValues } from '../PollForm';

type P = {
  poll: Poll;
};

const defaultQuestion = () => ({ choices: [{ name: '' }], multiple: true, question: '' });

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useGetPollInitialValues = ({ poll }: P): Partial<PollFormValues> =>
  useMemo(
    () => ({
      attachments: generateAttachmentsInputInitialValue(poll.attachments),
      community: poll.postInCommunities[0]
        ? { label: poll.postInCommunities[0].name, value: poll.postInCommunities[0].id }
        : undefined,
      description: poll.description,
      endTime: getDatePickerDateType(poll.endTime),
      htmlDescription: poll.htmlDescription,
      pinned: poll.pinned,
      programsTopicId: poll.programsTopicId,
      questions: poll.questions.length > 0 ? poll.questions : [defaultQuestion()],
      startTime: getDatePickerDateType(poll.startTime),
      title: poll.title,
    }),
    [poll],
  );
